import BasicRouterView from "../../components/BasicRouterView.vue";

const pdtRoutes = {
  path: "pdt",
  redirect: { name: "pdt-pt-listar" },
  meta: {
    label: "Permissão de Trabalho",
    icon: "assignment",
    show: true,
    favorite: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "permissao-de-Trabalho/listar",
      name: "pdt-pt-listar",
      meta: {
        label: "Listar",
        icon: "library_books",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./pt/views/Listar.vue"),
    },
    {
      path: "permissao-de-trabalho/listagem-geral-de-pts",
      name: "pdt-pt-listagem-geral",
      meta: {
        label: "Listagem Geral",
        icon: "list_alt",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./pt/views/ListagemGeralPt.vue"),
    },
    {
      path: "permissao-de-trabalho/emitir",
      name: "pdt-pt-emitir",
      meta: {
        label: "Emitir",
        icon: "assignment",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./pt/views/Emitir.vue"),
    },
    {
      path: "permissao-de-trabalho/unidade",
      redirect: { name: "pdt-atividades-unidade" },
      name: "pdt-unidade",
      meta: {
        label: "Configurar",
        icon: "engineering",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./unidade/views/ConfiguracaoUnidade.vue"
        ),
      children: [
        {
          path: "informacoe",
          name: "pdt-informacoes",
          meta: {
            label: "PDT Configurar Informações",
            icon: "settings",
            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./unidade/components/Informacoes.vue"
            ),
        },
        {
          path: "atividade",
          name: "pdt-atividades-unidade",
          meta: {
            label: "PDT Configurar Atividadde",
            icon: "library_books",
            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./unidade/components/Atividades.vue"
            ),
        },
        {
          path: "tipo-responsavel",
          name: "pdt-tipo-responsaveis",
          meta: {
            label: "PDT Configurar Responsavel",
            icon: "library_books",
            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./unidade/components/TipoResponsaveis.vue"
            ),
        },
        {
          path: "encerramento",
          name: "pdt-encerramento",
          meta: {
            label: "PDT Configurar Encerramento",
            icon: "settings",
            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./unidade/components/ListaEncerramento.vue"
            ),
        },
        {
          path: "modelo",
          name: "pdt-modelos",
          meta: {
            label: "PDT Configurar Modelos",
            icon: "view_module",
            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./unidade/components/Modelos.vue"
            ),
        },
        {
          path: ":modeloId/modelo-detalhe",
          name: "pdt-modelo-detalhe",
          meta: {
            label: "Detalhe do Modelo",
            icon: "view_module",
            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./unidade/views/DetalheModelo.vue"
            ),
        },
      ],
    },
    {
      path: ":unidadeId/atividade/:atividadeId",
      name: "pdt-atividade",
      meta: {
        label: "Configurar atividade",
        icon: "engineering",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./unidade/views/ConfiguracaoAtividade.vue"
        ),
    },
    {
      path: "permissao-de-trabalho/pt/:ptId",
      name: "pdt-pt-detalhe",
      redirect: { name: "pdt-pt-responsaveis" },
      meta: {
        label: "Detalhe",
        icon: "add",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./pt/views/Detalhe.vue"),
      children: [
        {
          path: "responsavel",
          name: "pdt-pt-responsaveis",
          meta: {
            label: "Reponsáveis",
            icon: "add",

            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./pt/components/Responsaveis.vue"
            ),
        },
        {
          path: "executante",
          name: "pdt-pt-executantes",
          meta: {
            label: "Executantes",
            icon: "add",

            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./pt/components/Executantes.vue"
            ),
        },
        {
          path: "avaliacao",
          name: "pdt-pt-avaliacao",
          meta: {
            label: "Avaliação de Risco",
            icon: "add",

            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./pt/components/AvaliacaoDeRisco.vue"
            ),
        },
        {
          path: "encerramento",
          name: "pdt-pt-encerramento",
          meta: {
            label: "Encerramento",
            icon: "add",

            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./pt/components/Encerramento.vue"
            ),
        },
        {
          path: "observacao",
          name: "pdt-pt-observacoes",
          meta: {
            label: "Observações",
            icon: "settings",
            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./pt/components/Observacoes.vue"
            ),
        },
        {
          path: "historico-status",
          name: "pdt-pt-status",
          meta: {
            label: "Histórico de Status",
            icon: "settings",
            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "pdt" */ "./pt/components/HistoricoStatus.vue"
            ),
        },
      ],
    },
    {
      path: "/permissao-de-trabalho/assinatura/responsavel/:ptId/:responsavelId",
      name: "pdt-pt-assinatura",
      meta: {
        label: "Assinatura",
        icon: "add",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./pt/views/AssinaturaResponsaveis.vue"
        ),
    },
    {
      path: "/permissao-de-trabalho/assinatura/executante/:ptId/:executanteId",
      name: "pdt-pt-assinatura-executante",
      meta: {
        label: "Assinatura",
        icon: "add",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./pt/views/AssinaturaExecutante.vue"
        ),
    },
    {
      path: "permissao-de-trabalho/assinatura/encerramento/:ptId/:responsavelId",
      name: "pdt-pt-assinatura-encerramento",
      meta: {
        label: "Assinatura",
        icon: "add",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./pt/views/AssinaturaEncerramento.vue"
        ),
    },
    {
      path: "permissao-de-trabalho/:ptId",
      name: "pdt-pt-imprimir",
      meta: {
        label: "Imprimir",
        icon: "add",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./pt/views/Imprimir.vue"),
    },
    {
      path: "permissao-de-trabalho/anexos/:ptId",
      name: "pdt-pt-imprimir-anexos",
      meta: {
        label: "Imprimir Anexos",
        icon: "add",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./pt/views/ImprimirAnexos.vue"),
    },
    {
      path: "permissao-de-trabalho/anexos/:ptId",
      name: "pdt-pt-anexos",
      meta: {
        label: "Anexos",
        icon: "add",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./pt/views/Anexos.vue"),
    },
  ],
};

export default pdtRoutes;
